/**
 * Shopify-like product handle slug: lowercase; non letter/digit runs → `-`;
 * trim edge hyphens; keep unicode letters (no transliteration).
 * Keep in sync with server `app/products/helpers/normalizeHandle.js`.
 *
 * @param {string} value
 * @returns {string}
 */
export default function normalizeHandle(value) {
  if (typeof value !== 'string') {
    return value;
  }

  return value
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, '-')
    .replace(/^-+|-+$/g, '');
}
